/**
 * Created by Administrador on 11/22/2016.
 */
(function(){
    'use strict';

    var navTab = {
        template: '<div class="pt-1 nav-tabs-bg">'+
        '<ul class="nav nav-tabs">'+
        '<li ng-class="{active: navTab.active}" ng-repeat="navTab in vm.navTabs">'+
        '<a ui-sref="{{navTab.route}}" id="{{navTab.heading}}Tab" title="{{navTab.heading | translate}}">{{navTab.heading | translate}}</a>'+
        '</li>'+
        '</ul></div>',
        controller: navTabController,
        controllerAs: 'vm',
        bindings:{
            tabs: '='
        }
    };

    angular
        .module('completeAir')
        .component('navTab', navTab);

    function navTabController(){
        var vm = this;

        vm.$onInit = function () {
            vm.navTabs = vm.tabs;
        }

    }
})();
